const cards = [
  {
    tag: '深度',
    title: '从顶流塌房看娱乐圈的流量泡沫：一个时代的终结？',
    desc: '近两年来多位顶流艺人接连翻车，背后是流量经济的系统性危机。本文深度分析娱乐圈的流量模式为何必然走向崩盘...',
    date: '3天前',
    reads: '12.8万',
    image: 'https://readdy.ai/api/search-image?query=Warm%20toned%20illustration%20of%20entertainment%20industry%20and%20celebrity%20culture%20analysis%2C%20magazine%20editorial%20style%2C%20soft%20coral%20and%20cream%20gradients%2C%20minimal%20flat%20vector%20art%2C%20contemplative%20mood&width=800&height=500&seq=cards-01&orientation=landscape',
  },
  {
    tag: '盘点',
    title: '今年最离谱的十大网红翻车事件，第一名你绝对想不到',
    desc: '从虚假人设到货不对板，今年网红圈的翻车事件层出不穷。我们盘点最令人瞠目结舌的十大事件...',
    date: '5天前',
    reads: '9.6万',
    image: 'https://readdy.ai/api/search-image?query=Teal%20and%20warm%20illustration%20of%20social%20media%20influencer%20controversies%2C%20ranking%20list%20concept%2C%20modern%20flat%20vector%20style%2C%20soft%20gradients%2C%20playful%20editorial%20aesthetic&width=800&height=500&seq=cards-02&orientation=landscape',
  },
  {
    tag: '追踪',
    title: '综艺选秀黑幕大起底：那些你不知道的行业潜规则',
    desc: '前选秀节目工作人员匿名爆料，揭秘选秀节目从海选到决赛的完整操作流程，内幕触目惊心...',
    date: '1周前',
    reads: '8.3万',
    image: 'https://readdy.ai/api/search-image?query=Coral%20and%20cream%20illustration%20about%20talent%20show%20behind%20the%20scenes%20expose%2C%20stage%20and%20drama%20elements%2C%20investigative%20journalism%20vibe%2C%20modern%20flat%20vector%20style&width=800&height=500&seq=cards-03&orientation=landscape',
  },
  {
    tag: '分析',
    title: 'CP营业是门技术活：为什么有的CP让人上头有的让人尴尬',
    desc: '从影视剧到综艺，CP营销已经成为标配。但为什么有些CP让人疯狂上头，有些却尴尬到脚趾抠地？专业分析来了...',
    date: '1周前',
    reads: '7.1万',
    image: 'https://readdy.ai/api/search-image?query=Warm%20toned%20romantic%20illustration%20of%20celebrity%20couple%20chemistry%20analysis%2C%20soft%20pink%20and%20coral%20gradients%2C%20editorial%20magazine%20style%2C%20modern%20flat%20vector%20art&width=800&height=500&seq=cards-04&orientation=landscape',
  },
  {
    tag: '独家',
    title: '某知名导演被爆片场霸凌演员，多位合作者站出发声',
    desc: '随着一位匿名演员的爆料，越来越多的圈内人开始站出来揭露该导演的恶劣行径，事件持续发酵...',
    date: '2周前',
    reads: '6.5万',
    image: 'https://readdy.ai/api/search-image?query=Teal%20and%20warm%20illustration%20of%20film%20industry%20controversy%20and%20workplace%20issues%2C%20dramatic%20mood%2C%20cinematic%20elements%2C%20modern%20flat%20vector%20style%2C%20soft%20gradients&width=800&height=500&seq=cards-05&orientation=landscape',
  },
  {
    tag: '八卦',
    title: '当红女星被偶遇与神秘男子同游日本，粉丝集体破防',
    desc: '有网友在东京银座偶遇某当红女星与一名男子亲密逛街，照片曝光后粉丝情绪激动，评论区炸了...',
    date: '2周前',
    reads: '5.8万',
    image: 'https://readdy.ai/api/search-image?query=Warm%20toned%20illustration%20of%20celebrity%20sighting%20and%20travel%20gossip%2C%20Tokyo%20cityscape%20elements%2C%20paparazzi%20vibe%2C%20modern%20flat%20vector%20style%2C%20coral%20and%20cream%20palette&width=800&height=500&seq=cards-06&orientation=landscape',
  },
  {
    tag: '观点',
    title: '国产剧为什么越来越难看？一位资深编剧的真心话',
    desc: '从剧本创作到平台审核，从演员片酬到制作周期，一位从业二十年的编剧说出了行业的残酷真相...',
    date: '3周前',
    reads: '5.2万',
    image: 'https://readdy.ai/api/search-image?query=Teal%20and%20coral%20illustration%20about%20television%20drama%20industry%20analysis%2C%20writing%20and%20creativity%20concept%2C%20thoughtful%20editorial%20style%2C%20modern%20flat%20vector%20art%2C%20soft%20gradients&width=800&height=500&seq=cards-07&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 px-4 md:px-6 bg-background-100 scroll-mt-20">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            精选瓜文
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            深度好文，吃瓜也要有营养，每篇都值得细细品读
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {cards.slice(0, 7).map((item, i) => (
            <div
              key={i}
              className={`group bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-200/60 transition-all duration-300 cursor-pointer ${
                i === 0 ? 'sm:col-span-2 lg:col-span-2 xl:col-span-2' : ''
              }`}
            >
              <div className={`relative overflow-hidden ${i === 0 ? 'h-56' : 'h-44'}`}>
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-accent-500 text-white text-xs font-medium rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className={`font-semibold text-foreground-900 mb-2 line-clamp-2 leading-snug ${
                  i === 0 ? 'text-base' : 'text-sm'
                }`}>
                  {item.title}
                </h3>
                <p className={`text-foreground-500 leading-relaxed line-clamp-2 mb-3 ${
                  i === 0 ? 'text-sm' : 'text-xs'
                }`}>
                  {item.desc}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{item.date}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.reads}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}